module.exports = __webpack_public_path__ + "img/bg3.cf6facaa.png";